import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import Option from './SelectRelacion';
import {
  faClipboardCheck,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faEdit,
  faFilter,
  faPlus,
  faTrashAlt,
  faImage,
  faInfo,
  faEye,
  faDownload,
  faUpload,
  faPrint,
  faSearch,
  faKey,
  faGasPump,
  faFileInvoice,
} from "@fortawesome/free-solid-svg-icons"

class Crear extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id_departamento: '',
            nombre: '',
            errores: [],
            filteredItems: [],
            idmenu: this.props.menu,
            isLoadingOpenSub: false,
            CampoInput: '',
            CampoInputName: '',
            searchTerm: ''
        };
        
        // Bind de métodos
        this.Seleccionar = this.Seleccionar.bind(this);
        this.cerrarModalSeleccion = this.cerrarModalSeleccion.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
    }
    
    saverel() {
        Swal.showLoading();
        let form = document.getElementById('form_registro_rel');
        let formData = new FormData(form);
        
        let u = localStorage.getItem('idusuario');

        authAxios.post(`master/registrar/` + this.props.menu + `/` + u, formData)
            .then((datosRespuesta) => {
                var status = datosRespuesta.data.status;

                if (datosRespuesta.data.Status) {
                    Swal.fire(
                        'Registro!',
                        datosRespuesta.data.msj,
                        'success'
                    );
                    document.getElementById("form_registro_rel").reset();
                    this.props.actualizarRelaciones(this.props.tabla[0].nombre_tabla, this.props.traevalor);
                } else {
                    Swal.close();
                    Swal.fire(
                        'Registro!',
                        datosRespuesta.data.msj,
                        'error'
                    );
                }
            })
            .catch(error => {
                Swal.close();
                console.error('Error:', error);
            });
    }
    
    seleccionador() {
        const idd = this.props.llave;
        //document.getElementById('').value =  this.props.relacionid;
    }
    
    componentDidMount() {
        this.seleccionador();
    }
    
    BuscarSub(tabla, id, nombre, campo) {
        this.setState({ 
            filteredItems: [],
            isLoadingOpenSub: true,
            CampoInput: campo, // Campo ID (hidden)
            CampoInputName: campo + "_name" // Campo nombre (visible)
        });
        
        console.log(tabla, id, nombre, campo);
        
        var da = { tabla, id, nombre };
        authAxios
            .post("master/relacion", da)
            .then((datosRespuesta) => {
                this.setState({ 
                    filteredItems: datosRespuesta.data,
                    isLoadingOpenSub: false 
                });
            })
            .catch(error => {
                console.error('Error en BuscarSub:', error);
                this.setState({ isLoadingOpenSub: false });
            });
    }
    
    Seleccionar(id, nombre) {
        const { CampoInput, CampoInputName } = this.state;
        
        console.log('Seleccionando:', id, nombre);
        console.log('Campos a llenar:', CampoInput, CampoInputName);
        
        // Llenar ambos campos
        if (CampoInput) {
            const idField = document.getElementById(CampoInput);
            if (idField) idField.value = id;
        }
        
        if (CampoInputName) {
            const nameField = document.getElementById(CampoInputName);
            if (nameField) nameField.value = nombre;
        }
        
        // Cerrar solo el modal de selección
        this.cerrarModalSeleccion();
        
        // Limpiar término de búsqueda
        this.setState({ searchTerm: '' });
    }
    
    cerrarModalSeleccion() {
        // Método seguro que no depende de jQuery o Bootstrap global
        const modalElement = document.getElementById('ModalSelectSub');
        if (modalElement) {
            // Remover clases de Bootstrap para ocultar el modal
            modalElement.classList.remove('show');
            modalElement.style.display = 'none';
            
            // Remover la clase 'modal-open' del body
            document.body.classList.remove('modal-open');
            
            // Remover el backdrop del modal
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => {
                backdrop.remove();
            });
            
            // Restablecer el estilo del body
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        }
    }
    
    handleSearchChange(e) {
        this.setState({ searchTerm: e.target.value });
    }
    
    handleCloseModal = () => {
        this.cerrarModalSeleccion();
        this.setState({ searchTerm: '' });
    }
    
    renderFieldSub(row, key) {
        if (row.nombre_campo === 'id') {
            return null;
        }
        if (this.props.llave === row.nombre_campo) {
            return (
                <input 
                    className="form-control form-control-sm" 
                    readOnly 
                    type="hidden" 
                    name={row.nombre_campo} 
                    id={row.nombre_campo} 
                    value={this.props.relacionid} 
                    key={key}
                />
            );
        }
        return (
            <div className="col-md-4" key={key}>
                {row.tipo_dato === 'blob' || row.tipo_dato === 'checkbox' ? (
                    row.tipo_dato === 'blob' ? (
                        <div className="gallery my-gallery card-body row">
                            <figure className="col-xl-12 col-md-12 col-12">
                                <a href="" target="_blank" data-size="1600x950">
                                    <img 
                                        className="img-thumbnail" 
                                        id={`img${row.nombre_campo}`} 
                                        src="http://www.losprincipios.org/images/default.jpg" 
                                        alt="Image description" 
                                    />
                                </a>
                                <figcaption>{row.nombre_titulo}</figcaption>
                            </figure>
                        </div>
                    ) : (
                        <div className="form-check" style={{ marginTop: '10px' }}>
                            <input 
                                className="form-check-input" 
                                readOnly={row.campo_editable === "Si" ? false : true} 
                                type="checkbox" 
                                name={row.nombre_campo} 
                                id={row.nombre_campo} 
                            />
                            <label className="form-check-label" htmlFor={row.nombre_campo} style={{ marginLeft: '5px' }}>
                                {row.nombre_titulo} 
                                {row.obligatorio === '1' ? <span className="text-danger">*</span> : ''}
                            </label>
                        </div>
                    )
                ) : (
                    <label htmlFor={row.nombre_campo}>
                        {row.nombre_titulo} 
                        {row.obligatorio === '1' ? <span className="text-danger">*</span> : ''}
                    </label>
                )}

                {row.tipo_dato === 'checkbox' ? null : row.trae_tabla === null ? (
                    <input 
                        className="form-control form-control-sm" 
                        readOnly={row.campo_editable === "Si" ? false : true} 
                        type={row.tipo_dato === 'int' ? 'number' : 
                              row.tipo_dato === 'date' ? 'date' : 
                              row.tipo_dato === 'time' ? 'time' : 
                              row.tipo_dato === 'blob' ? 'file' : 'text'} 
                        name={row.nombre_campo} 
                        id={row.nombre_campo} 
                    />
                ) : (
                    <>
                        <input
                            className="form-control form-control-sm"
                            readOnly={row.campo_editable === "Si" ? false : "readOnly"}
                            type="hidden"
                            name={row.nombre_campo}
                            id={row.nombre_campo}
                        />
                        <div className="input-group mb-3">
                            <input
                                className="form-control form-control-sm"
                                readOnly="readOnly"
                                type="text"
                                name={`${row.nombre_campo}_name`}
                                id={`${row.nombre_campo}_name`}
                            />
                            <button
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => this.BuscarSub(
                                    row.trae_tabla,
                                    row.trae_value,
                                    row.trae_campo,
                                    row.nombre_campo
                                )}
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#ModalSelectSub"
                            >
                                <FontAwesomeIcon icon={faSearch} />
                            </button>
                        </div>
                    </>
                )}
            </div>
        );
    }

    renderTabFieldsSub(pestana) {
        const fields = this.props.tabla.filter(row => row.pestana === pestana);
        const result = [];
        let currentGroup = null;
        let currentGroupFields = [];

        const flushGroup = (key) => {
            if (currentGroupFields.length > 0) {
                const groupName = currentGroup;
                const fieldsToRender = [...currentGroupFields];
                result.push(
                    <div className="col-12" key={`group-wrapper-${groupName}-${key}`} style={{ marginBottom: "15px" }}>
                        <fieldset style={{
                            border: "2px solid #000000",
                            borderRadius: "8px",
                            padding: "20px 20px 10px 20px",
                            position: "relative",
                            marginTop: "15px"
                        }}>
                            <legend style={{
                                position: "absolute",
                                top: "-12px",
                                left: "20px",
                                background: "#ffffff",
                                padding: "0 10px",
                                fontSize: "14px",
                                fontWeight: "bold",
                                width: "auto",
                                float: "none",
                                color: "#333333"
                            }}>
                                {groupName}
                            </legend>
                            <div className="row">
                                {fieldsToRender.map((row, idx) => this.renderFieldSub(row, `${key}-${idx}`))}
                            </div>
                        </fieldset>
                    </div>
                );
                currentGroupFields = [];
            }
        };

        fields.forEach((row, i) => {
            if (row.nombre_campo === 'id') {
                result.push(
                    <input 
                        type="hidden" 
                        name={row.nombre_campo} 
                        id={row.nombre_campo} 
                        placeholder={row.nombre_campo}
                        key={`id-${i}`}
                    />
                );
                return;
            }

            const hasGroup = row.grupo && row.grupo.trim() !== "";
            if (hasGroup) {
                if (currentGroup && currentGroup !== row.grupo) {
                    flushGroup(i);
                }
                currentGroup = row.grupo;
                currentGroupFields.push(row);
            } else {
                flushGroup(i);
                currentGroup = null;
                result.push(this.renderFieldSub(row, i));
            }
        });

        flushGroup(fields.length);
        return result;
    }

    render() {
        const { 
            filteredItems, 
            isLoadingOpenSub, 
            searchTerm
        } = this.state;
        
        // Filtrar items basado en searchTerm
        const filtered = filteredItems.filter(item =>
            String(item.nombre || '').toLowerCase().includes(searchTerm.toLowerCase())
        );
        
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <form id="form_registro_rel">
                            <div>
                                <div className="card-body">
                                    <h5>Formulario de Registro</h5>
                                    <ul className="nav nav-tabs" id="icon-tab" role="tablist">
                                        {this.props.pesta.map((row, i) => (
                                            <li key={i} className="nav-item">
                                                <a 
                                                    className={i === 0 ? "nav-link active" : "nav-link"} 
                                                    id={`icon-home-tab-${i}`}
                                                    data-bs-toggle="tab" 
                                                    href={`#icon-${row.pestana?row.pestana:'Basico'}`} 
                                                    role="tab" 
                                                    aria-controls={`icon-${row.pestana?row.pestana:'Basico'}`} 
                                                    aria-selected={i === 0}
                                                >
                                                    <i className={i === 0 ? 'icofont icofont-ui-home' : 'icofont icofont-files'}></i>
                                                    {row.pestana?row.pestana:'Basico'}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>

                                    <div className="tab-content" id="icon-tabContent">
                                        {this.props.pesta.map((fila, i) => (
                                            <div 
                                                className={i === 0 ? "tab-pane fade show active" : "tab-pane fade"} 
                                                id={`icon-${fila.pestana?fila.pestana:'Basico'}`} 
                                                role="tabpanel" 
                                                aria-labelledby={`icon-${fila.pestana?fila.pestana:'Basico'}-tab`}
                                                key={i}
                                            >
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="card">
                                                            <div className="row card-body">
                                                                {this.renderTabFieldsSub(fila.pestana)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-primary btn-sm" onClick={() => this.saverel()}>
                                        Guardar Registro
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                {/* Modal para seleccionar registro */}
                <div className="modal fade" id="ModalSelectSub" tabIndex="-1" aria-labelledby="ModalSelectSubLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="ModalSelectSubLabel">
                                    Seleccione el registro
                                </h5>
                                <button 
                                    type="button" 
                                    className="btn-close" 
                                    onClick={this.handleCloseModal}
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                <div>
                                    <input
                                        type="text"
                                        placeholder="Buscar por descripción..."
                                        className="form-control mb-3"
                                        value={searchTerm}
                                        onChange={this.handleSearchChange}
                                    />
                                    
                                    {isLoadingOpenSub ? (
                                        <div className="text-center">
                                            <div className="spinner-border" role="status">
                                                <span className="visually-hidden">Cargando...</span>
                                            </div>
                                            <p className="mt-2">Cargando registros...</p>
                                        </div>
                                    ) : filtered.length === 0 ? (
                                        <div className="text-center">
                                            <p>{searchTerm ? 'No se encontraron resultados' : 'No hay registros disponibles'}</p>
                                        </div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-hover table-sm">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>DESCRIPCIÓN</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filtered.map((item) => (
                                                        <tr 
                                                            key={item.id} 
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => this.Seleccionar(item.id, item.nombre)}
                                                        >
                                                            <td>{item.id}</td>
                                                            <td>
                                                                <button  type="button" 
                                                                    className="btn btn-link p-0 text-decoration-none text-start"
                                                                    onClick={() => this.Seleccionar(item.id, item.nombre)}
                                                                >
                                                                    {item.nombre}
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button 
                                    type="button" 
                                    className="btn btn-secondary" 
                                    onClick={this.handleCloseModal}
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;